import PropTypes from 'prop-types';
import { createContext, useContext, useState } from 'react';

import DetailContentSubTask from '@/widgets/Projekte/DetailsContentSubTask';

const ProjectDetailsContext = createContext(undefined);
export const useProjectDetailsContext = () => useContext(ProjectDetailsContext);

export function ProjectDetailsContextProvider({ children }) {
  const [subitem, setSubitem] = useState(null);

  const close = () => {
    setSubitem(null);
  };

  const showTask = (pid, tid, sid) => {
    setSubitem({ pid, tid, sid });
  };

  return (
    <ProjectDetailsContext.Provider value={{ showTask }}>
      {subitem ? <DetailContentSubTask close={close} subitem={subitem} /> : null}
      {children}
    </ProjectDetailsContext.Provider>
  );
}

ProjectDetailsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ProjectDetailsContextProvider;
